import React, { Component } from "react";
import PropTypes from "prop-types";
import { Link } from "react-router-dom";
import IErrorDTO from "../../../models/DTO/IErrorDTO";
import IGetForecastGroupDTO from "../../../models/DTO/IGetForecastGroupDTO";
import IGetForecastGroupsDTO from "../../../models/DTO/IGetForecastGroupsDTO";
import IOnGetForecastGroupDTO from "../../../models/DTO/IOnGetForecastGroupDTO";
import IOnGetForecastGroupsDTO from "../../../models/DTO/IOnGetForecastGroupsDTO";
import IAction from "../../../models/IAction";
import IBreadcrumbs from "../../../models/IBreadcrumbs";
import IForecast_Group from "../../../models/IForecast_Group";
import IForecast_Item from "../../../models/IForecast_Item";
import INavItem from "../../../models/INavItem";
import IOwTableCols from "../../../models/IOwTableCols";
import ISupplierModel from "../../../models/ISupplierModel";
import IUserUI from "../../../models/IUserUI";
import IVendorModel from "../../../models/IVendorModel";
import Breadcrumbs from "../../shared/Breadcrumbs/Breadcrumbs";
import OwActionBar from "../../shared/OwActionBar/OwActionBar";
import OwButton from "../../shared/OwButton/OwButton";
import OwCheckbox from "../../shared/OwCheckbox/OwCheckbox";
import OwLabel from "../../shared/OwLabel/OwLabel";
import OwTable from "../../shared/OwTable/OwTable";
import OwTitle from "../../shared/OwTitle/OwTitle";
import ForecastSidebar from "../ForecastSidebar/ForecastSidebar";
import moment from "moment";
import ExcelJS from 'exceljs/dist/exceljs.min.js';
import * as _ from "lodash-es";
import { Socket } from "socket.io-client";

type Props = {
    history?: any;
    userModel: IUserUI;
    supplierModel: ISupplierModel;
    vendorModel: IVendorModel;
    setActivityIndicator?: (activityIndicator: boolean) => void;
    socket: Socket;
    notifyFn: (data: IErrorDTO | null, _notification?: any, isFormatted?: boolean) => void;
    setSidebarComponent: (component: any) => void;
    toggleSidebar: (shouldBeVisible?: boolean) => void;
};

type State = {
    navItems: IBreadcrumbs[];
    columns: IOwTableCols[];
    forecastGroups: IForecast_Group[];
    dataFetchActive: boolean;
    initialData: boolean;
    actions: IAction[];
    excelExportActive: boolean;
    checkedRows: any;
};

class Forecast extends Component<Props, State> {
    constructor(props: any) {
        super(props);

        const columns: IOwTableCols[] = [
            { title: "actions", valueProp: "", isActionsCol: true, renderFn: this.actionsCol },
            { title: "catalog", valueProp: "Catalog", valueSubProp: "name" },
            { title: "year", valueProp: "period_year", renderFn: this.determineYear },
            { title: "period", valueProp: "period_start", renderFn: this.determineHalf },
        ];

        if (this.props.userModel.isSupplierUser) {
            columns.splice(1, 0, { title: "vendor", valueProp: "Vendor", valueSubProp: "name", isVendorOverride: true });
        }

        this.state = {
            navItems: [
                { title: "Dashboard", url: "/dashboard" },
                { title: "Forecast", url: "/forecast" },
            ],
            columns,
            forecastGroups: [],
            dataFetchActive: false,
            initialData: true,
            actions: [],
            excelExportActive: false,
            checkedRows: {},
        };
    }

    componentDidMount(): void {
        const actions: IAction[] = [];

        if (this.props.userModel.isSupplierUser) {
            actions.push({
                name: "export_to_excel",
                isActive: this.state.excelExportActive,
                fn: this.exportToExcel,
                disabledFn: this.excelExportDisabledFn,
                leftIconClass: "fad fa-file-excel",
            });
        }

        this.props.socket.on("onGetForecastGroups", this.onGetForecastGroups);
        this.props.socket.on("onGetForecastGroup", this.onGetForecastGroup);

        this.setState(
            {
                actions,
            },
            () => {
                this.getForecastGroups();
            }
        );
    }

    componentWillUnmount(): void {
        this.props.socket.removeListener("onGetForecastGroups", this.onGetForecastGroups);
        this.props.socket.removeListener("onGetForecastGroup", this.onGetForecastGroup);
    }

    excelExportDisabledFn = (): boolean => {
        const keys = Object.keys(this.state.checkedRows);

        let hasOnlyOneChecked = true;

        let count = 0;

        for (const key of keys) {
            if (this.state.checkedRows[key]) {
                count++;
            }
        }

        if (count > 1) {
            hasOnlyOneChecked = false;
        }

        if (!count) {
            hasOnlyOneChecked = false;
        }

        console.log("excelExportDisabledFn", !hasOnlyOneChecked);

        return !hasOnlyOneChecked;
    };

    exportToExcel = () => {
        let selectedForecastGroupGuid = "";

        for (const key of Object.keys(this.state.checkedRows)) {
            if (this.state.checkedRows[key]) {
                selectedForecastGroupGuid = key;
            }
        }

        // perform retrieval of the forecast group.
        const payload: IGetForecastGroupDTO = {
            userToken: this.props.userModel.token,
            userGuid: this.props.userModel.guid,
            supplierGuid: this.props.supplierModel.guid,
            forecastGroupGuid: selectedForecastGroupGuid,
        };

        this.props.socket.emit("getForecastGroup", payload);
        // console.log('exportToExcel');
    };

    // This function is CURRENTLY only used when performing an export to Excel.
    onGetForecastGroup = (data: IOnGetForecastGroupDTO) => {
        this.generateExcelExport(data);
    };

    calculateRowTotal = (row: IForecast_Item): number => {
        const month_one = row.month_one ? Number(row.month_one) : 0;
        const month_two = row.month_two ? Number(row.month_two) : 0;
        const month_three = row.month_three ? Number(row.month_three) : 0;
        const month_four = row.month_four ? Number(row.month_four) : 0;
        const month_five = row.month_five ? Number(row.month_five) : 0;
        const month_six = row.month_six ? Number(row.month_six) : 0;

        return month_one + month_two + month_three + month_four + month_five + month_six;
    };

    generateExcelExport = (data: IOnGetForecastGroupDTO) => {
        const workbook = new ExcelJS.Workbook();

        workbook.creator = "Orderwerks";
        workbook.created = new Date();
        workbook.modified = new Date();

        const sheet = workbook.addWorksheet("Forecast");

        let months = ["January", "February", "March", "April", "May", "June"];

        const yearHalf = this.determineHalf(data.period_start);

        if (yearHalf !== "H1") {
            months = ["July", "August", "September", "October", "November", "December"];
        }

        const columns = [
            {
                header: "Catalog Item",
                key: "catalog_item_name",
            },
            {
                header: "SKU",
                key: "sku",
            },
        ];

        const index = 1;
        for (const month of months) {
            let key = "";

            switch (index) {
                case 1:
                    key = "month_one";
                    break;

                case 2:
                    key = "month_two";
                    break;

                case 3:
                    key = "month_three";
                    break;

                case 4:
                    key = "month_four";
                    break;

                case 5:
                    key = "month_five";
                    break;

                case 6:
                    key = "month_six";
                    break;
            }

            columns.push({
                header: month,
                key,
            });
        }

        columns.push({
            header: "Total",
            key: "total",
        });

        sheet.columns = columns;

        let forecastItems = data.Forecast_Items;

        // compile each item from the payload as rows
        if (forecastItems) {
            const addRows: any[] = [];

            // sort forecast items by catalog item name
            forecastItems = _.sortBy(forecastItems, (item) => {
                return item.Catalog_Item?.name;
            });

            for (const row of forecastItems) {
                // let data: any = {
                //     catalog_item_name: row.Catalog_Item? row.Catalog_Item.name : "",
                //     sku: row.Catalog_Item? row.Catalog_Item.sku : "",
                //     month_one: row.month_one? row.month_one : 0,
                //     month_two: row.month_two? row.month_two : 0,
                //     month_three: row.month_three? row.month_three : 0,
                //     month_four: row.month_four? row.month_four : 0,
                //     month_five: row.month_five? row.month_five : 0,
                //     month_six: row.month_six? row.month_six : 0,
                // };

                const data = [
                    row.Catalog_Item ? row.Catalog_Item.name : "",
                    row.Catalog_Item ? row.Catalog_Item.sku : "",
                    row.month_one ? row.month_one : 0,
                    row.month_two ? row.month_two : 0,
                    row.month_three ? row.month_three : 0,
                    row.month_four ? row.month_four : 0,
                    row.month_five ? row.month_five : 0,
                    row.month_six ? row.month_six : 0,
                    this.calculateRowTotal(row),
                ];

                // console.log('Add Row', data);

                addRows.push(data);
            }

            sheet.addRows(addRows);
        }

        workbook.xlsx.writeBuffer().then((fileBuffer) => {
            const blob = new Blob([fileBuffer], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" });
            const link = document.createElement("a");
            link.href = window.URL.createObjectURL(blob);

            const periodYear = moment(data.period_year).format("YYYY");
            let vendorName = data.Vendor ? data.Vendor.name : "";

            vendorName = vendorName.replace(/ /g, "-").replace(/\./g, "");

            const fileName = `Orderwerks-Forecast-${periodYear}-${yearHalf}-${vendorName}.xlsx`;

            link.download = fileName;
            link.click();
        });
    };

    setChecked = (e: any) => {
        console.log("setChecked", e);
        const checkedGuid = e.target.name;

        const checkedRows = this.state.checkedRows;

        // only allow 1 row to be checked
        for (const key of Object.keys(checkedRows)) {
            if (checkedRows[key]) {
                checkedRows[key] = false;
            }
        }

        checkedRows[checkedGuid] = e.target.value;

        this.setState({
            checkedRows,
        });
    };

    actionsCol = (data: IForecast_Group) => {
        return (
            <div>
                {this.props.userModel.isSupplierUser ? (
                    <OwCheckbox
                        name={data.guid}
                        truthyVal={true}
                        falsyVal={false}
                        fn={this.setChecked}
                        checked={this.state.checkedRows[data.guid]}
                    />
                ) : null}
                <Link className={"ms-2"} to={`/forecast/${data.guid}`}>
                    <u>
                        <OwLabel leftIconClass={"far fa-eye"} title={"view"} noBottomMargin={true} className={"pointer"} />
                    </u>
                </Link>
            </div>
        );
    };

    determineHalf = (data: string): string => {
        return moment(data).quarter() <= 2 ? "H1" : "H2";
    };

    determineYear = (data: string): string => {
        return moment(data).format("YYYY");
    };

    getForecastGroups = () => {
        const payload: IGetForecastGroupsDTO = {
            userToken: this.props.userModel.token,
            userGuid: this.props.userModel.guid,
            supplierGuid: this.props.supplierModel.guid,
        };

        if (!this.props.userModel.isSupplierUser) {
            payload.vendorGuid = this.props.vendorModel.guid;
        }

        this.props.socket.emit("getForecastGroups", payload);

        this.setState({
            dataFetchActive: true,
        });
    };

    onGetForecastGroups = (data: IOnGetForecastGroupsDTO) => {
        const checkedRows = this.state.checkedRows;

        for (const forecastGroup of data.forecastGroups) {
            if (!checkedRows[forecastGroup.guid]) {
                checkedRows[forecastGroup.guid] = false;
            }
        }

        this.setState({
            forecastGroups: data.forecastGroups,
            initialData: false,
            dataFetchActive: false,
            checkedRows,
        });
    };

    toggleSidebar = (shouldBeVisible?: boolean) => {
        this.props.toggleSidebar(shouldBeVisible);

        this.getForecastGroups();
    };

    getForecastGroupSidebar = (forecastGroup?: IForecast_Group) => {
        return (
            <ForecastSidebar
                history={this.props.history}
                cancelFn={this.toggleSidebar}
                socket={this.props.socket}
                userModel={this.props.userModel}
                supplierModel={this.props.supplierModel}
                vendorModel={this.props.vendorModel}
            />
        );
    };

    createForecastGroup = (forecastGroup?: IForecast_Group) => {
        const forecastGroupSidebar = this.getForecastGroupSidebar(forecastGroup);
        this.props.setSidebarComponent(forecastGroupSidebar);
        this.props.toggleSidebar(true);
    };

    render() {
        return (
            <div className="Forecast">
                <Breadcrumbs navItems={this.state.navItems} />
                <div className={"d-flex align-items-center"}>
                    <OwTitle title={"forecast"} leftIconName={"fad fa-chart-line"} />
                    <OwButton
                        title={"create"}
                        leftIconClass={"far fa-plus"}
                        className={"ms-2 btn-warning"}
                        fn={() => {
                            this.createForecastGroup();
                        }}
                    />
                </div>

                <div>{/* Filter Here */}</div>
                <div>
                    <OwActionBar
                        actions={this.state.actions}
                        toggleSmallTable={(isSmallTable) => {}}
                        colToggledFn={() => {}}
                        columns={{}}
                        hideColumnToggle={true}
                        hideTableTypeSelect={true}
                        disabled={false}
                    />
                </div>
                <div>
                    <OwTable
                        userModel={this.props.userModel}
                        supplierModel={this.props.supplierModel}
                        columns={this.state.columns}
                        dataSet={this.state.forecastGroups}
                        dataFetch={this.state.dataFetchActive}
                        initialData={this.state.initialData}
                    />
                </div>
            </div>
        );
    }
}

export default Forecast;
